<template>
    <div class="contentHome">
        <div class="centerPage">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
                <el-breadcrumb-item>
                    <a href="/publicWelfare" class="aHref">公益科普</a>
                </el-breadcrumb-item>
                <el-breadcrumb-item>科普详情</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="infoCon">
                <div class="contentHeight">
                    <h3>{{details.title}}</h3>
                    <p class="readingTime">
                        <span>发布人：{{item.name}}</span>
                        <span>发布时间：{{details.publishDate}}</span>
                        <span>{{details.viewsCount}}阅读</span>
                        <span class="belongTo">{{item.type}}</span>
                    </p>
                    <div v-if="details.thumbnailPath" :style="'background: url('+details.thumbnailPath+') no-repeat;height: 330px;backgroundSize: 80%;backgroundPosition: center;'"></div>
                    <div class="narrate ban-cp" v-html="details.pageContent" style="white-space: pre-line"></div>
					<router-link v-if="needLogin" to="/login" class="checkAll">登录/注册查看全部文章</router-link>
                </div>
                <div class="flex artFoot">
                    <div class="share flex">
                        <span>分享：</span>
                        <el-popover popper-class="popoverText" style="display: none"
                          placement="top"
                          width="100"
                          trigger="hover">
                            <div class="shareImg" slot="reference">
                                <img src="../../assets/img/wx_a.png" alt="" class="block">
                                <img src="../../assets/img/wx_b.png" alt="" class="none">
                            </div>
                            <div class="txt">
                                <img :src="wx" alt="" width="80">
                                <p>微信扫一扫<br>分享至朋友圈</p>
                            </div>
                        </el-popover>
                        <el-popover popper-class="popoverText"
									placement="top"
									width="100"
									trigger="hover"
                                    :disabled="true">
                            <div class="shareImg" slot="reference">
                                <img src="../../assets/img/qq_a.png" alt="" class="block">
                                <img src="../../assets/img/qq_b.png" @click="share('qq')" alt="" class="none">
                            </div>
                        </el-popover>
                        <el-popover popper-class="popoverText"
									placement="top"
									width="100"
									trigger="hover"
                                    :disabled="true">
                            <div class="shareImg" slot="reference">
                                <img src="../../assets/img/wb_a.png" alt="" class="block">
                                <img src="../../assets/img/wb_b.png" @click="share('wb')" alt="" class="none">
                            </div>
                        </el-popover>
                    </div>
                    <span class="subscription flex" @click="dialogVisible=true" v-if="concern !== '未登录'"><img
                            src="../../assets/img/subscription.png" alt="" width="13">{{concern}}</span>
                    <div class="admire flex" @click="likes">
                            <img src="../../assets/img/dz_a.png" alt="" v-if="admire==0">
                            <img src="../../assets/img/dz_b.png" alt="" v-else>
                            <span :class="admire!=0?'classText':''">点赞<span>{{details.likesCount}}</span></span>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
        width="400px"
        :visible.sync="loginDialogVisited">
            <div slot="title" >
                <i style="color: #e6a23c;font-size: 24px" class="el-icon-warning-outline"></i>
                <span style="font-size: 20px;display: inline-block;height: 24px;line-height: 24px;vertical-align: 2px;">用户未登录：</span>
            </div>
            <div style="font-size: 14px">
                <el-link icon="el-icon-s-custom" type="primary" href="/login">已有账号，去登录</el-link>
                <span>，还没有账号？</span>
                <el-link icon="el-icon-unlock" type="primary" href="/registered">去注册一个新账号</el-link>
            </div>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :show-close="false"
                class="tips paySuccess"
                top="0"
                :visible.sync="dialogVisible"
                width="400px">
            <img src="../../assets/img/tips.png" alt="" width="140">
            <p>{{concernMessage}}</p>
            <div class="sub">
                <el-button @click="dialogVisible=false">取消</el-button>
                <el-button v-if="concern==='订阅文章'" @click="addConcern">确定</el-button>
                <el-button v-if="concern==='取消订阅'" @click="delConcern">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import base from '@/api/common';

    export default {
        name: "publicWelfareDetail",
        data() {
            return {
                needLogin: false,
                loginDialogVisited: false,
                item: {
                    id: this.$route.query.id,
                    name: this.$route.query.d,
                    type: this.$route.query.t,
                },
                wx: '/static/imgs/pay_a.png',
                admire: 0,
                details: {},
                dialogVisible:false,

                concernMessage: "",
                concern: "",
            }
        },
        async mounted() {

            document.onmousedown = function(e){
                if(e.button==2){
                    e.returnValue=false;
                }
            };

            document.addEventListener("copy",function(e){
                //取消默认事件，才能修改复制的值
                e.preventDefault();
                //复制的内容
                let copyTxt = `${window.location.href}`;
                if(e.clipboardData) {
                    e.clipboardData.setData('text/plain',  copyTxt);
                }
                else if(window.clipboardData){
                    return window.clipboardData.setData("text", copyTxt);
                }
            });

            let that = this;
            let url = base.api.article.science.details.replace("{id}", this.item.id); //默认未登录用户
            let currentUser = await base.utils.getCurrent();
            if (currentUser) {
                url = base.api.article.science.details_auth.replace("{id}", this.item.id);
                this.getConcern();
            } else {
                this.concern = "未登录";
            }

            if (this.item && this.item.id) {
                this.$ajax.get(url).then((res) => {
                    if (res.data.status === 'success') {
                        this.details = res.data.data;
                    }else if(res.data.status === 'needUserLogin'){ // 需要登录
                        this.needLogin = true;
                    } else {
                        that.$router.back();
                    }
                });
                this.$ajax.get(base.api.article.science.isLiked.replace("{id}", this.item.id)).then((res) => {
                    if (res.data.status === 'success') {
                        this.admire = res.data.data;
                    }
                });
            } else {
                this.$router.back();
            }


        },
        methods: {
            likes(id) {
                if (this.admire == 0) {
                    if (this.item.id) {
                        this.$ajax.post(base.api.article.science.likes.replace("{id}", this.item.id)).then(()=>{
                            this.admire = 1;
                            this.details.likesCount++;
                        }).catch((err) => {
                            if (err.response.status === 401) {
                                this.loginDialogVisited = true;
                            }
                        });
                    }
                }
            },
            share(code){
                let url,params;
                if(code === 'qq'){
                    url = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?";
                    params = {
                        url: location.href,
                        title: this.details.title,
                        desc: "",
                        summary: this.details.summary.substr(0,50) + "...",
                        site: '{{200*100}}',
                        pics: this.details.thumbnailPath
                    };
                }else if(code === 'wb'){
                    url = "http://service.weibo.com/share/share.php?";
                    params = {
                        url: location.href,
                        title: this.details.title,
                        pic: this.details.thumbnailPath
                    };
                }
                window.open(url + $.param(params),'_blank')
            },
            trueSubscription() {
                this.dialogVisible = false
                this.$message({
                    message: "订阅成功！",
                    type: "success"
                })
            },
            getConcern() {
                let that = this;
                this.$ajax
                    .get(base.api.article.concern.get.replace("{type}",3))
                    .then(function (res) {
                      if (res.data.status === 'success') {
                        if (res.data.data) {
                          that.concernMessage = '是否确定取消订阅文章？';
                          that.concern = "取消订阅";
                        } else {
                          that.concernMessage = '是否确定订阅文章？';
                          that.concern = "订阅文章";
                        }
                      }
                    })
            },
            addConcern() {
                this.dialogVisible = false
                let that = this;
                this.$ajax.post(base.api.article.concern.add.replace("{type}",3))
                    .then(function (res) {
                        if (res.data.status === 'success') {
                          that.$message.success('操作成功');
                        } else {
                          that.$message.error(res.data.message);
                        }
                        that.getConcern()
                    }).catch((err) => {
                  console.error(err);
                  that.$message.error('操作失败');
                })
            },
            delConcern() {
                this.dialogVisible = false
                let that = this;
                this.$ajax.delete(base.api.article.concern.delete.replace("{type}",3))
                    .then(function (res) {
                        if (res.data.status === 'success') {
                          that.$message.success('操作成功');
                        } else {
                          that.$message.error(res.data.message);
                        }
                        that.getConcern()
                    }).catch((err) => {
                  console.error(err);
                  that.$message.error('操作失败');
                })
            },
        }
    }
</script>

<style scoped lang="scss">
@import '../../assets/css/news.scss';
.ban-cp{moz-user-select: -moz-none;
    -moz-user-select: none;
    -o-user-select:none;
    -khtml-user-select:none;
    -webkit-user-select:none;
    -ms-user-select:none;
    user-select:none;}
</style>